var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{attrs:{"id":"app"}},[_c('h1',[_vm._v("aiMee")]),_c('img',{attrs:{"src":require("@/assets/aiMee-logo.png"),"alt":"aiMee","height":_vm.logoHeight}}),_c('MainPage')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }